import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/2452527b-ebab-4367-a964-9cf54228f6c4";
export const REGISTER_URL = "https://a.ntrk2.com/abb787da-aafb-40a4-9d20-9964ee67a919";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://easylux.kzw2a.com/download?openExternalBrowser=1&id=2tmwz6axns7p97p";

export * from "./codes";
export * from "./context";
